var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNightingaleRoundIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1_copy",
    "data-name": "Layer 1 copy",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #b9d794;\n      }\n\n      .cls-2 {\n        fill: #ffe52f;\n      }\n\n      .cls-3 {\n        fill: #5b3914;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 50,
    cy: 50,
    r: 50
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1159",
    "data-name": "Group 1159"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1469",
    "data-name": "Path 1469",
    className: "cls-2",
    d: "M66.4942,74.7347a26.8362,26.8362,0,1,1,0-49.3936,26.84,26.84,0,0,0,0,49.3936Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1470",
    "data-name": "Path 1470",
    className: "cls-3",
    d: "M55.9835,23.2017a26.6241,26.6241,0,0,1,10.511,2.1394,26.84,26.84,0,0,0,0,49.3936,26.8372,26.8372,0,1,1-10.511-51.533m0-6.0961a32.9325,32.9325,0,0,0,0,65.865,32.6223,32.6223,0,0,0,12.9122-2.6378,6.0905,6.0905,0,0,0-.0151-11.2057,20.7437,20.7437,0,0,1,0-38.178,6.0943,6.0943,0,0,0,.0151-11.2107A32.6812,32.6812,0,0,0,55.9835,17.1056Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNightingaleRoundIcon);
export default __webpack_public_path__ + "static/media/nightingale-round-icon.03c26b059398191be44e96d68a15ed91.svg";
export { ForwardRef as ReactComponent };